import {
    NON_ENGINEERS_REQUEST,
    NON_ENGINEERS_SUCCESS,
    NON_ENGINEERS_FAILURE,
    STORE_NON_ENGINEER_REQUEST,
    STORE_NON_ENGINEER_SUCCESS,
    STORE_NON_ENGINEER_FAILURE,
    UPDATE_NON_ENGINEER_REQUEST,
    UPDATE_NON_ENGINEER_SUCCESS,
    UPDATE_NON_ENGINEER_FAILURE,
    NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    NON_ENGINEER_DOCUMENT_DELETE_REQUEST,
    NON_ENGINEER_DOCUMENT_DELETE_SUCCESS,
    NON_ENGINEER_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const NON_ENGINEERS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null,
};

import nonEngineer from './non-engineer';
const nonEngineerReducer = (state, action) => {
    let {data} = state;
    const {nonEngineer: id} = action;
    const eng = data.find(b => b.id === id);
    const reduced = nonEngineer(eng, action);
    data.splice(data.indexOf(eng), 1, reduced);
    data = [...data];

    return {...state, data};
};

const nonEngineersReducers = {
    [NON_ENGINEERS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [NON_ENGINEERS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [NON_ENGINEERS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_NON_ENGINEER_REQUEST]: (state, action) => {
        const admin = nonEngineer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), admin];

        return {...state, data};
    },
    [STORE_NON_ENGINEER_SUCCESS]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = nonEngineer(admin, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_NON_ENGINEER_FAILURE]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = nonEngineer(admin, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_NON_ENGINEER_REQUEST]: nonEngineerReducer,
    [UPDATE_NON_ENGINEER_SUCCESS]: nonEngineerReducer,
    [UPDATE_NON_ENGINEER_FAILURE]: nonEngineerReducer,
    [NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST]: nonEngineerReducer,
    [NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: nonEngineerReducer,
    [NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE]: nonEngineerReducer,
    [NON_ENGINEER_DOCUMENT_DELETE_REQUEST]: nonEngineerReducer,
    [NON_ENGINEER_DOCUMENT_DELETE_SUCCESS]: nonEngineerReducer,
    [NON_ENGINEER_DOCUMENT_DELETE_FAILURE]: nonEngineerReducer,
};

export default function nonEngineers(state = NON_ENGINEERS_INITIAL_STATE, action) {
    let reducer = nonEngineersReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/non-engineers.js